import _ from 'lodash';
import React from 'react';
import OpeningHours from './OpeningHours';

class OpeningHoursContainer extends React.Component {
  render() {
    const { data, day, onUpdate, ...otherProps } = this.props;

    const timeranges = _.get(data, `openingHoursByDay.${day}.openingHours`, []);
    const note = _.get(data, `openingHoursByDay.${day}.note`, '');

    return (
      <OpeningHours
        timeranges={timeranges}
        note={note}
        onTimerangesChange={newTimeranges => {
          onUpdate(data, {
            openingHoursByDay: {
              [day]: { openingHours: { $set: newTimeranges } }
            }
          });
        }}
        onNoteChange={newNote => {
          onUpdate(
            data,
            {
              openingHoursByDay: {
                [day]: { note: { $set: newNote } }
              }
            },
            true,
            false
          );
        }}
        {...otherProps}
      />
    );
  }
}

export default OpeningHoursContainer;



// WEBPACK FOOTER //
// ./src/commons/components/OpeningHoursContainer.jsx